export const APP_LOCALES = ['zh-CN', 'ko-KR'];
export const DEFAULT_LOCALE = 'zh-CN';
//# sourceMappingURL=auth.js.map